import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useRetrieveTeam, useRetrieveUserTeamPermissions, } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Forbidden } from "../nav/Forbidden";
import { Loading } from "../nav/Loading";
import { useNumericParams } from "../utils/useNumericParams";
import { IntraSquadTournamentForm } from "./IntraSquadTournamentForm";
export var CreateIntraSquadTournament = function () {
    var teamId = useNumericParams().id;
    var _a = useRetrieveUserTeamPermissions({ teamId: teamId }), userTeamPermissions = _a.data, userTeamPermissionsIsLoading = _a.isLoading, userTeamPermissionsError = _a.error;
    var _b = (userTeamPermissions || {}).canModify, canModify = _b === void 0 ? false : _b;
    var _c = useRetrieveTeam({ id: teamId, enabled: canModify }), useRetrieveTeamIsLoading = _c.isLoading, useRetrieveTeamError = _c.error, team = _c.data;
    var loading = userTeamPermissionsIsLoading || useRetrieveTeamIsLoading;
    if (loading) {
        return _jsx(Loading, {});
    }
    if (!canModify) {
        return _jsx(Forbidden, {});
    }
    var dataError = !team || !userTeamPermissions;
    if (dataError) {
        return (_jsx(ErrorView, { error: new Error("Unable to retrieve tournament data!") }));
    }
    var error = useRetrieveTeamError || userTeamPermissionsError;
    if (error) {
        return _jsx(ErrorView, { error: error });
    }
    return (_jsx(React.Fragment, { children: _jsx(IntraSquadTournamentForm, { team: team }) }));
};
